"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _FromList = _interopRequireDefault(require("@/components/FromList"));
var _devise = require("@/api/devise");
var _permission = require("@/utils/permission");
var _default2 = require("@/views/pagediy/advertisement/default");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'index',
  components: {
    FromList: _FromList.default
  },
  data: function data() {
    return {
      swiperOption: {
        //显示分页
        pagination: {
          el: '.swiper-pagination'
        },
        //设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        //自动轮播
        autoplay: {
          delay: 2000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false
        },
        //开启循环模式
        loop: false
      },
      advertisementConfig: Object.assign({}, (0, _default2.advertisementDefault)()),
      //选择链接数据
      activeIndex: 0,
      splashFrom: {
        adList: [],
        splashAdShowInterval: 0,
        splashAdShowTime: 0,
        splashAdSwitch: 0
      },
      loadingBtn: false
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:page:layout:splash:ad:get'])) this.getAdvertisement();
  },
  methods: {
    // 开屏广告新增
    handleAdvertisementSave: function handleAdvertisementSave() {
      var _this = this;
      this.advertisementConfig.list.map(function (item, index) {
        item.sort = index + 1;
      });
      var data = _objectSpread(_objectSpread({}, this.splashFrom), {}, {
        adList: this.advertisementConfig.list
      });
      this.loadingBtn = true;
      (0, _devise.splashSaveApi)(data).then(function (res) {
        _this.$message.success('保存成功');
        _this.loadingBtn = false;
        _this.getAdvertisement();
      }).catch(function () {
        _this.loadingBtn = false;
      });
    },
    // 开屏广告数据
    getAdvertisement: function getAdvertisement() {
      var _this2 = this;
      (0, _devise.splashGetApi)().then(function (res) {
        _this2.splashFrom = res;
        _this2.advertisementConfig.list = res.adList;
      });
    }
  }
};